import { format } from 'date-fns';
import { Suspense } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { COLLECTION_DATE_FORMAT } from '../constants';
import { type DOI } from '../utils/doi';
import { DOIBadge } from './DOIBadge';
import { LoadInstrumentUrl } from './LoadInstrumentUrl';
import { MetadataElement } from './MetadataElement';
import { MetadataElementList } from './MetadataElementList';
import { Publisher } from './Publisher';

export function DOIMetatada({ doi }: { doi: DOI }) {
  const createdDate = doi.createdDate
    ? format(doi.createdDate, COLLECTION_DATE_FORMAT)
    : undefined;

  return (
    <Card>
      <Card.Header className="p-2">Metadata</Card.Header>
      <Card.Body className="pt-0 p-2">
        <Col>
          <MetadataElement title="Identifier">
            <DOIBadge doi={doi.doi} />
          </MetadataElement>

          {doi.proposals.length > 0 && doi.instruments.length > 0 && (
            <Row>
              <Col>
                <MetadataElementList
                  title={`Proposal${doi.proposals.length > 1 ? 's' : ''}`}
                  values={doi.proposals}
                />
              </Col>
              <Col>
                <MetadataElementList
                  title={`Beamline${doi.instruments.length > 1 ? 's' : ''}`}
                  values={doi.instruments}
                >
                  {(val) => (
                    <Suspense fallback={val}>
                      <LoadInstrumentUrl instrument={val} />
                    </Suspense>
                  )}
                </MetadataElementList>
              </Col>
            </Row>
          )}

          <MetadataElement title="Public release year">
            {doi.publicationYear}
          </MetadataElement>

          <MetadataElement title="Session date">
            {doi.collectionDate}
          </MetadataElement>

          <MetadataElementList title="Category" values={doi.categories} />

          <MetadataElement title="Publisher">
            <Publisher doi={doi} />
          </MetadataElement>

          {doi.rights && (
            <MetadataElement title="License (for files)">
              <a
                href={
                  doi.rights.rightsURI ||
                  'https://creativecommons.org/licenses/by/4.0/'
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {doi.rights.rights || 'Creative Commons Attribution 4.0'}
              </a>
            </MetadataElement>
          )}

          <MetadataElement title="Deposit date">{createdDate}</MetadataElement>
        </Col>
      </Card.Body>
    </Card>
  );
}
